export const SIZE = {
    MEDIUM: 'medium',
    LARGE: 'large'
};